<template>
  <v-container fluid>
    <v-card class="mt-5" elevation="0">
      <v-card-text>
        <v-row class="align-center">
          <v-col cols="12" lg="6" class="d-flex flex-wrap flex-lg-nowrap">
            <v-text-field class="me-lg-3" label="Filter monitoring items" prepend-inner-icon="fa-search" v-model="filter.search" clearable dense solo-inverted/>
            <v-menu v-model="menuPickerStart" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-datetime-picker label="Date Start" v-bind="attrs" v-on="on" v-model="filter.datePickerStart" date-format="dd/MM/yyyy" :textFieldProps="{dense: true, soloInverted: true, class: ['me-lg-3']}" :timePickerProps="{format: '24hr'}">
                  <template v-slot:dateIcon>
                    <v-icon>fa-calendar</v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon>fa-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </template>
            </v-menu>
            <v-menu v-model="menuPickerEnd" :close-on-content-click="false" max-width="290">
              <template v-slot:activator="{ on, attrs }">
                <v-datetime-picker label="Date End" v-bind="attrs" v-on="on" v-model="filter.datePickerEnd" date-format="dd/MM/yyyy" :textFieldProps="{dense: true, soloInverted: true, class: ['me-lg-3']}" :timePickerProps="{format: '24hr'}">
                  <template v-slot:dateIcon>
                    <v-icon>fa-calendar</v-icon>
                  </template>
                  <template v-slot:timeIcon>
                    <v-icon>fa-clock</v-icon>
                  </template>
                </v-datetime-picker>
              </template>
            </v-menu>
          </v-col>
          <v-col cols="12" lg="6" class="d-flex align-center justify-lg-end mb-5">
            <v-dialog v-model="dialogPickerHeaders" width="500" dark>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mr-2" elevation="0" color="primary" outlined v-bind="attrs" v-on="on"><i class="fas fa-sliders-h"></i></v-btn>
                <v-btn :loading="reportLoading" class="mr-2" elevation="0" outlined @click="callInitiateCsvReport" >
                  <span>CSV</span>
                  <i class="fas fa-download"></i>
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h5 ">Header columns</v-card-title>
                <v-card-text class="py-5">
                  <v-select v-model="selectedHeaders" :items="headers" label="Select Columns" multiple outlined return-object>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index < 3">
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 3" class="grey--text caption">&nbsp;(+{{ selectedHeaders.length - 3 }} others)</span>
                    </template>
                  </v-select>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogPickerHeaders = false">I accept</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-data-table
          @update:items-per-page="itemsPerPageChange"
          class="elevation-0"
          :loading="loading"
          :headers="selectedHeaders"
          :items="collection"
          :options.sync="options"
          :server-items-length="totalCollection"
          :footer-props="{
            'items-per-page-options': [50, 100, 200, 500]
          }"
        >
          <!-- Slots and Table Content -->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'Reports',
  components: {},
  data: () => ({
    loading: true,
    checkReportInterval: null,
    reportLoading: false,
    numberOfPages: 0,
    totalCollection: 100,
    collection: [],
    options: {},
    filter: {},
    dialogPickerHeaders: false,
    menuPickerStart: false,
    menuPickerEnd: false,
    selectedHeaders: []
  }),
  watch: {
    options: {
      async handler () {
        await this.changeData()
      }
    },
    'filter.search': {
      handler () {
        this.changeData()
      }
    },
    'filter.datePickerStart': {
      handler () {
        this.changeData()
      }
    },
    'filter.datePickerEnd': {
      handler () {
        this.changeData()
      }
    },
    deep: true
  },
  methods: {
    changeData () {
      if (this.storePaginationSort !== this.options) {
        this.$store.dispatch('reportPaginationSort', this.options)
      }

      if (this.storeFilter !== this.filter) {
        this.$store.dispatch('reportFilter', this.filter)
      }

      this.callFetchData()
    },
    callFetchData: _.debounce(function () {
      this.fetchData()
    }, 100),
    getDataForOrders () {
      const paginationSortOptions = this.storePaginationSort

      return {
        rowsPerPage: paginationSortOptions.itemsPerPage === 10 ? 50 : paginationSortOptions.itemsPerPage,
        tz: new Date().getTimezoneOffset(),
        sortBy: paginationSortOptions.sortBy,
        sortDesc: paginationSortOptions.sortDesc,
        filter: this.storeFilter
      }
    },
    async fetchData () {
      this.loading = true
      // Получаем текущие параметры пагинации
      const paginationSortOptions = this.storePaginationSort

      // Сохраняем предыдущую страницу, чтобы отслеживать изменения
      const previousPage = this.previousPage || paginationSortOptions.page

      // URL для получения данных на основе текущей страницы
      const url = `reports?page=${paginationSortOptions.page}`

      // Выполняем запрос на получение данных
      await axios.post(url, this.getDataForOrders()).then(response => {
        this.loading = false
        this.collection = response.data.data

        // Если текущая страница больше предыдущей (то есть пользователь листает вперед)
        if (paginationSortOptions.page > previousPage) {
          this.totalCollection += response.data.to - response.data.from
        } else if (paginationSortOptions.page < previousPage) {
          this.totalCollection -= response.data.to - response.data.from
        }

        // Обновляем previousPage для следующего вызова
        this.previousPage = paginationSortOptions.page
      }).catch(error => {
        this.loading = false
        console.log(error)
        alert('Error: see in console')
      })
    },
    callInitiateCsvReport: _.debounce(async function () {
      await this.initiateCsvReport()
    }, 100),

    async checkReportStatus (id) {
      try {
        const { data: { status, payload } } = await axios.get(`reports/csv/status/${id}`)

        if (status === 'OK') {
          if (payload.status === 'complete') {
            window.open(payload.downloadUrl, '_blank')
            /* .focus() */
            clearInterval(this.checkReportInterval)
            this.reportLoading = false
            return true
          }
        }
      } catch (error) {
        console.log(error)
        alert('Error: see in console')
      }
    },
    async initiateCsvReport () {
      if (this.storePaginationSort !== this.options) {
        await this.$store.dispatch('orderPaginationSort', this.options)
      }

      if (this.storeFilter !== this.filter) {
        await this.$store.dispatch('orderFilter', this.filter)
      }

      const paginationSortOptions = this.storePaginationSort

      try {
        this.reportLoading = true
        const { data: { status, request_id: requestId } } = await axios.post(`reports/csv?page=${paginationSortOptions.page}`, {
          ...this.getDataForOrders(),
          columns: this.selectedHeaders?.filter(({ value }) => value).map(({ value }) => value)
        })

        if (status === 'OK') {
          if (!(await this.checkReportStatus(requestId))) {
            this.checkReportInterval = setInterval(async () => {
              await this.checkReportStatus(requestId)
            }, 2000)
          }
        }
      } catch (error) {
        this.reportLoading = false
        console.log(error)
      }
    },
    changeColorFilter (obj) {
      return obj && obj.length > 0 ? 'accent' : 'default'
    },
    itemsPerPageChange (itemsPerPage) {
      this.totalCollection = itemsPerPage + itemsPerPage
    }
  },
  computed: {
    headers () {
      const data = [
        {
          text: 'Дата заказа',
          value: 'created_at',
          role: 'all'
        },
        {
          text: 'ID',
          value: 'contractor_order_id',
          role: 'all'
        },
        {
          text: 'Agent ID',
          value: 'agent_order_id',
          role: 'all'
        },
        {
          text: 'Class',
          value: 'class',
          role: 'all'
        },
        {
          text: 'User',
          value: 'user_type',
          role: 'all'
        },
        {
          text: 'Сумма заказа',
          value: 'price_raw',
          role: 'all'
        },
        {
          text: 'Редактировалась ли цена',
          value: 'changed_price_raw',
          sortable: false,
          role: 'all'
        },
        {
          text: 'Дата корректировки',
          value: 'updated_at',
          role: 'all'
        },
        {
          text: 'Доля яндекса в %',
          value: 'contractor_percent',
          sortable: false,
          role: 'contractor'
        },
        {
          text: 'Доля лидера в %',
          value: 'aggregator_percent',
          sortable: false,
          role: 'aggregator'
        },
        {
          text: 'Доля в %',
          value: 'agent_percent',
          sortable: false,
          role: 'agent'
        },
        {
          text: 'Доля яндекса в деньгах',
          value: 'contractor_money',
          sortable: false,
          role: 'contractor'
        },
        {
          text: 'Доля лидера в деньгах',
          value: 'aggregator_money',
          sortable: false,
          role: 'aggregator'
        },
        {
          text: 'Доля в деньгах',
          value: 'agent_money',
          sortable: false,
          role: 'agent'
        }
      ]

      if (this.$store.state.auth.user.show_special_tariff) {
        data.push({
          text: 'Special tariff',
          value: 'special_tariff',
          sortable: false,
          role: 'all'
        })
      }

      let dataHeaders = null
      const role = this.$store.state.auth.user.role
      // Returns available columns
      dataHeaders = data.map(function (value) {
        if (role === 'aggregator') {
          return value
        }

        if (value.role === role || value.role === 'all') {
          return value
        }
      })

      // Remove all undefined
      Object.keys(dataHeaders).forEach(key => {
        if (dataHeaders[key] === undefined) {
          delete dataHeaders[key]
        }
      })

      return dataHeaders
    },
    dateStartFormatted () {
      return this.filter.datePickerStart ? moment(this.filter.datePickerStart).format('DD/MM/YYYY H:i') : ''
    },
    dateEndFormatted () {
      return this.filter.datePickerEnd ? moment(this.filter.datePickerEnd).format('DD/MM/YYYY H:i') : ''
    },
    storeFilter () {
      return this.$store.state.reports.reportFilter
    },
    storePaginationSort () {
      return this.$store.state.reports.reportPaginationSort
    }
  },
  async mounted () {
    this.selectedHeaders = this.headers
    this.options = this.$store.state.reports.reportPaginationSort
    this.filter = this.$store.state.reports.reportFilter
  }
}
</script>
